import {FETCH_POSTS, NEW_POST,REMOVE_ITEM} from '../actions/types';

const initialState = {
  items: [],
  item: {},
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_POSTS:
      return {
        ...state,
        items: action.payload
      };

    case NEW_POST:
      return {
        ...state,
        item: action.payload
      };

    case REMOVE_ITEM:
         return{
       ...state,
           item:action.payload
         }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/quotaReducer.js